__turbopack_context__.v({
  "author": "FqEfaa_author",
  "authorRow": "FqEfaa_authorRow",
  "date": "FqEfaa_date",
  "imgPlaceholder": "FqEfaa_imgPlaceholder",
  "imgWrapper": "FqEfaa_imgWrapper",
  "reviewContent": "FqEfaa_reviewContent",
  "reviewRow": "FqEfaa_reviewRow",
});
